








































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  Team,
  User,
  Rubric,
  CreateRubric,
  RubricUpdate,
  Question
} from "@/types";
import { Getter, Action } from "vuex-class";
import Trash from "@/assets/images/icons/trash.svg?inline";
import Dots from "@/assets/images/icons/dots.svg?inline";
import {
  fetchDefaultRubric,
  createRubric,
  setDefaultRubric,
  updateRubric,
  deleteRubric
} from "@/api.ts";
import draggable from "vuedraggable";
const vClickOutside = require("v-click-outside");

@Component({
  components: {
    Dots,
    Trash,
    draggable
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
})
export default class ReviewManageRubric extends Vue {
  @Getter private JWT!: string;
  @Getter private currentTeamID!: string;
  @Getter private currentTeam?: Team;
  @Action private setDisplayError: any;
  @Prop() private changeTeam!: (teamID: any) => any;

  private editingQuestionIndex: number = -1;
  private rubricFromApi: any;
  private rubric: any = {
    name: new Date().toDateString(),
    questions: []
  };

  private created() {
    this.copyObject();
    this.fetchDefaultRubric();
  }

  private handleChange(event: any) {
    let oldIndex = event.moved.newIndex;
    let newIndex = event.moved.oldIndex;

    let min = 0;
    let max = this.rubric.questions.length;

    if (oldIndex < newIndex) {
      min = oldIndex;
      max = newIndex;
    } else {
      min = newIndex;
      max = oldIndex;
    }

    for (let i = min; i < max + 1; i++) {
      this.rubric.questions[i].displayOrder = i + 1;
    }
  }

  private addQuestion() {
    let max = 0;
    if (this.rubric.questions) {
      for (let i = 0; i < this.rubric.questions.length; ++i) {
        max = Math.max(max, this.rubric.questions[i].displayOrder);
      }
      this.rubric.questions.push({
        question: "",
        displayOrder: max + 1
      });
    } else {
      this.rubric.questions = [
        {
          question: "",
          displayOrder: max + 1
        }
      ];
    }

    this.editingQuestionIndex = this.rubric.questions.length - 1;
  }

  private editQuestion(index: number) {
    this.editingQuestionIndex = index;
  }

  get isDataChanged() {
    return JSON.stringify(this.rubric) !== JSON.stringify(this.rubricFromApi);
  }

  private saveRubric() {
    this.onFilteredEmptyQuestions();
    if (this.isDataChanged) {
      if (!this.rubric.rubricSlug) {
        this.createRubric();
      } else {
        if (this.rubric.questions.length == 0) {
          this.deleteRubric();
        } else {
          this.updateRubric();
        }
      }
    }
  }

  private showSuccessToast() {
    this.$bvToast.toast("Rubric saved", {
      noCloseButton: true,
      variant: "success",
      autoHideDelay: 2000,
      solid: true
    });
  }

  private onFilteredEmptyQuestions() {
    this.editingQuestionIndex = -1;
    let questionsFiltered = this.rubric.questions.filter(
      (question: Question) => {
        return question.question != null && question.question.length > 0;
      }
    );
    if (this.rubric.questions.length !== questionsFiltered.length) {
      this.rubric.questions = questionsFiltered;
    }
  }

  private deleteQuestion(index: number) {
    if (this.rubric.questions.length) {
      this.rubric.questions.splice(index, 1);
    }

    for (let i = index; i < this.rubric.questions.length; i++) {
      this.rubric.questions[i].displayOrder = i + 1;
    }

    if (this.editingQuestionIndex > -1) {
      this.editingQuestionIndex === -1;
    }
  }

  @Watch("currentTeamID")
  private fetchDefaultRubric() {
    if (this.currentTeamID) {
      fetchDefaultRubric(
        this.JWT,
        this.currentTeamID,
        (rubric: Rubric) => {
          this.rubric = rubric;
          this.copyObject();
        },
        (error: string) => {
          this.rubric.questions = [];
          this.rubric.rubricSlug = null;
          this.rubric.version = null;
          this.copyObject();
        }
      );
    }
  }

  private createRubric() {
    createRubric(
      this.JWT,
      this.currentTeamID,
      this.rubric,
      (createRubric: CreateRubric) => {
        this.rubric.rubricSlug = createRubric.rubricSlug;
        this.rubric.version = createRubric.version;
        this.copyObject();
        this.setDefaultRubric();
      },
      (error: string) => {
        this.setDisplayError(error);
      }
    );
  }

  private setDefaultRubric() {
    setDefaultRubric(
      this.JWT,
      this.rubric.rubricSlug,
      (response: any) => {
        this.showSuccessToast();
      },
      (error: string) => {
        this.setDisplayError(error);
      }
    );
  }

  private updateRubric() {
    updateRubric(
      this.JWT,
      this.rubric,
      (response: RubricUpdate) => {
        this.rubric.version = response.version;
        this.copyObject();
        this.setDefaultRubric();
      },
      (error: string) => {
        this.setDisplayError(error);
      }
    );
  }

  private deleteRubric() {
    deleteRubric(
      this.JWT,
      this.rubric,
      (response: any) => {
        this.copyObject();
        this.showSuccessToast();
      },
      (error: string) => {
        this.setDisplayError(error);
      }
    );
  }

  private initRubric() {
    this.rubric = {
      name: new Date().toDateString(),
      questions: []
    };
    this.copyObject();
  }

  private copyObject() {
    this.rubricFromApi = JSON.parse(JSON.stringify(this.rubric));
  }
}
